// Sidebar akun pajak: Pajak Pusat (role 8) dan Pajak Cabang (role 9, hanya Monitoring cabangnya)
export default [
  {
    component: 'CNavTitle',
    name: 'Faktur Pajak',
  },
  {
    component: 'CNavItem',
    name: 'Monitoring Faktur',
    to: '/pajak/monitoring',
    icon: 'cil-task',
  },
  {
    component: 'CNavItem',
    name: 'Pencocokan Faktur',
    to: '/pajak/pencocokan',
    icon: 'cil-check-circle',
    hideForRoles: ['9'],
  },
  {
    component: 'CNavItem',
    name: 'Pengaturan Pajak',
    to: '/pajak/pengaturan',
    icon: 'cil-settings',
    hideForRoles: ['9'],
  },
]
